export default "/images/eec868621488cce0788c359a2ef29022.avif";